module.exports = __webpack_public_path__ + "3c6832fed25a12f35c5dbf59f7e5c3ac.png";